import api from '../../api/'
const state = {
    all:[]
}

const getters= {
    rows(state){
        let data = []
        let row = {
            id: "",
            entite_nom: "",
            name: "",
            email: "",
            agence_nom:"",
            agence_ville:"",
            role_name: "",
            active: "",
            created_at: null,
            updated_at: null,
            deleted_at: null,
            btn:""
        }
        state.all.forEach(element => {    
            console.log('mon roles ',element)       
            row = {
                id: element.id,
                entite_nom: element.entite_nom == null ? null : element.entite_nom.toUpperCase(),
                agence_nom: element.agence_nom == null ? null : element.agence_nom.toUpperCase(),
                agence_ville: element.agence_ville == null ? null : element.agence_ville.toUpperCase(),
                name: element.name.toUpperCase(),
                email: element.email,
                role_name: element.role_name,
                active: element.active === 1 ? 'activé' : 'désactivé',
                created_at: element.created_at,
                deleted_at: element.deleted_at,
                updated_at: element.updated_at,
                //btn: "<router-link to='/theme/users/show/"+element.id+"'><button class='btn btn-pill btn-success'><i class='fa fa-plus'></i></button></router-link><button class='btn btn-pill btn-info'><i class='fa fa-pencil'></i></button><button class='btn btn-pill btn-danger'><i class='fa fa-trash'></i></button>"
            }
            data.push(row)
        });
        return data;
    }
}
const mutations= {
    setuser(state, users) {
        state.all = users
    },
    adduser(state,user){
        state.all.push(user)
    }
}

const actions={
    async get_all_users({ commit }, serverParams){
        return api.user.get_all_users(serverParams).then((response)=>{ 
            console.log("mes users ",response)       
            if (response.data.data.data!==undefined){
                commit('setuser', response.data.data.data)
            }else{
                commit('setuser', response.data.data)
            }
            return response.data.data
        })
    },
    async get_all_users_own({ commit }, serverParams){
        return api.user.get_all_users_own(serverParams).then((response)=>{
            commit('setuser', response.data.data.data)
            return response.data.data
        })
    },
    async get_all_users_by_entity({ commit },id){
        return api.user.get_all_users_by_entity(id).then((response)=>{
            commit('setuser', response.data.data.data)
            return response.data.data
        })
    },
    async get_all_users_by_user({ commit },id){
        return api.user.get_all_users_by_user(id).then((response)=>{
            commit('setuser', response.data.data.data)
            return response.data.data
        })
    },
    post_users({commit},user){
        
        return api.user.post_users(user).then(response=>{
            commit('adduser', response.data.data)
            return response.data
        })
        .catch(error=>{
            return error.response.data
        })
    },
    forget_password({commit},user){
        return api.user.forget_password(user).then(response=>{
            //commit('adduser', response.data.data)
            return response.data
        })
        .catch(error=>{
            return error.response.data
        })
    },
    put_users({ commit }, data) {
        return api.user.put_users(data.id, data.user).then((response) => {
            return response.data
        })
            .catch(error => {
                return error.response.data
            })
    },
    show_users({ commit }, id) {
        return api.user.show_users(id).then((response) => {
            return response.data.data;
        })
    },
    desactive_users({ commit }, id) {
        return api.user.desactive_users(id).then((response) => {
            return response.data;
        })
        .catch(error => {
            return error.response.data
        })
    },
    active_users({ commit }, id) {
        return api.user.active_users(id).then((response) => {
            return response.data;
        })
        .catch(error => {
            return error.response.data
        })
    },
    delete_users({ commit }, id) {
        return api.user.delete_users(id).then((response) => {
            return response.data;
        })
        .catch(error => {
            return error.response.data
        })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
